(function(window, angular){'use strict';

var ngModule = angular.module('pp.filters.serialize-json', []);

ngModule.filter('ppSerializeJson', function () {
    return function (value) {
        return JSON.stringify(value);
    };
});
})(window, window.angular);